<template>
  <div>
    <issue-template ref="template" :type="type" @issue="issue" @restore="restore"/>
    <vxe-loading v-model="loading"/>
  </div>
</template>
<script>
import { post } from '@/api/Api'
import api from '@/api'
import IssueTemplate from '@/views/outbound/issue/IssueTemplate.vue'

export default {
  name: 'OneStepOrder',
  components: { IssueTemplate },
  data() {
    return {
      loading: false,
      type: 'oneStep'
    }
  },
  methods: {
    issue(orderId) {
      this.loading = true
      post(api.dispatchSubmit, {}, { id: orderId }).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.issueSuccess'))
          this.$refs.template.refresh()
        }
      }).finally(() => this.loading = false)
    },
    restore(orderId) {
      this.loading = true
      post(api.dispatchSwitchOneStep, {}, { id: orderId, oneStep: false }).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.$refs.template.refresh()
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>